import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { AuthService } from '../data-access/auth.service';
import { ProfileService } from '../data-access/user.service';

/**
 * Interceptor for handling custom HTTP response headers.
 *
 * This interceptor monitors HTTP responses for specific custom headers and executes
 * corresponding actions when detected. Add new header checks and handlers directly
 * in this file as needed.
 *
 * Currently supported headers:
 * - `X-User-Profile-Updated`: Triggers automatic user profile refetch
 */
export const withCustomHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const userService = inject(ProfileService);

  return next(req).pipe(
    tap({
      next: response => {
        if ('headers' in response) {
          if (response.headers.has('X-User-Profile-Updated')) {
            handleProfileUpdate(authService, userService);
          }
        }
      },
    })
  );
};

/**
 * Handles the X-User-Profile-Updated header.
 * Refetches the user profile and updates the global state.
 */
function handleProfileUpdate(authService: AuthService, userService: ProfileService): void {
  authService.getUserProfile().subscribe({
    next: profile => {
      userService.setUserProfile(profile);
    },
    error: error => {
      console.error('Failed to refetch user profile after server update:', error);
    },
  });
}
